import React from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";

const ContainerDiv = styled.div`
  background: var(--main-btn-bg);
  box-shadow:
    0 6px 20px -4px var(--main-btn-shadow),
    0 2px 20px -4px rgb(0 0 0 / 22%),
    0 0 10px -4px #fff;
  cursor: pointer;
  border-radius: 1rem;
  border: var(--main-btn-border);
  transition: all 0.3s ease;
  :hover {
    transform: scale(0.95);
  }

  .img-link-bio {
    flex: 0 0 5rem;
    max-width: 5rem;
    margin-right: 1rem;

    img {
      border-top-left-radius: 1rem;
      border-bottom-left-radius: 1rem;
      max-width: 5rem;
      height: 5rem;
      padding: 1rem;
      background: #000;
    }
  }

  .link-bio-heading {
    color: var(--main-btn-color);
    font-size: 1.3rem;
    font-weight: 700;
  }
`;

const InternalLinkBio = ({ options }) => {
  const { objinfo = {} } = options;
  const { icon, link, heading } = objinfo || {};

  return (
    <ContainerDiv className="t-mb-2">
      <Link to={link} className="t-flex-ac">
        <div className="img-link-bio">
          <img src={icon} alt={heading} />
        </div>
        <span className="link-bio-heading">{heading}</span>
      </Link>
    </ContainerDiv>
  );
};

export default InternalLinkBio;
